export const NAV_ITEMS = [
  { slug: "home", label: "Home", to: "/" },
  { slug: "start-here", label: "Start Here", to: "/start-here" },
  { slug: "eternal-life", label: "Eternal Life", to: "/eternal-life" },
  { slug: "know-jesus", label: "Know Jesus", to: "/know-jesus" },
  { slug: "the-gospel", label: "The Gospel", to: "/the-gospel" },
  { slug: "what-we-believe", label: "What We Believe", to: "/what-we-believe" },
  { slug: "bible-studies", label: "Bible Studies", to: "/bible-studies" },
  { slug: "articles", label: "Articles", to: "/articles" },
  { slug: "devotionals", label: "Daily Devotional", to: "/devotionals" },
  { slug: "questions", label: "Questions & Answers", to: "/questions" },
  { slug: "kids", label: "Kids & Families", to: "/kids" },
  { slug: "about", label: "About", to: "/about" },
  { slug: "contact", label: "Contact", to: "/contact" },
];

export const HEADER_PRIMARY_NAV = [
  { slug: "start-here", label: "Start Here", to: "/start-here" },
  { slug: "eternal-life", label: "Eternal Life", to: "/eternal-life" },
  { slug: "gospel", label: "The Gospel", to: "/the-gospel" },
  { slug: "believe", label: "What We Believe", to: "/what-we-believe" },
  { slug: "bible-studies", label: "Bible Studies", to: "/bible-studies" },
  { slug: "articles", label: "Articles", to: "/articles" },
  { slug: "kids", label: "Kids", to: "/kids" },
  { slug: "questions", label: "Q&A", to: "/questions" },
];

export const GOSPEL_SIX_TRUTHS = [
  {
    n: 1,
    title: "God the Creator",
    scripture: "Genesis 1:1; Colossians 1:16",
    body:
      "In the beginning, God created the heavens and the earth. He made humanity in His image to know Him, love Him, and reflect His goodness.",
  },
  {
    n: 2,
    title: "Humanity and Sin",
    scripture: "Romans 3:23; Romans 5:12",
    body:
      "Every person has turned from God. Sin is not merely wrong actions but a rebel heart. It brings guilt, brokenness, and separation from the God who is life.",
  },
  {
    n: 3,
    title: "God's Holiness and Justice",
    scripture: "Habakkuk 1:13; Romans 6:23",
    body:
      "God is holy — He cannot ignore or excuse sin. Yet He is also love, and He longs to reconcile us. Our great problem is: how can a holy God forgive rebels justly?",
  },
  {
    n: 4,
    title: "Jesus Christ Crucified",
    scripture: "Isaiah 53:5; 1 Peter 2:24",
    body:
      "God's answer is a cross. Jesus, the sinless Son of God, willingly bore our sin and God's just judgment. At the cross, holiness and love meet perfectly.",
  },
  {
    n: 5,
    title: "Jesus Christ Risen",
    scripture: "1 Corinthians 15:3–8",
    body:
      "Jesus rose bodily from the dead on the third day, defeating sin and death. His resurrection vindicates His words and secures ours.",
  },
  {
    n: 6,
    title: "Repentance and Faith",
    scripture: "Acts 3:19; Ephesians 2:8–9",
    body:
      "The Gospel calls for a response: turn from sin, trust in Jesus, and receive forgiveness and eternal life. Salvation is a gift — not a wage — for anyone who will receive it.",
  },
];

export const PATHWAY_CARDS = [
  {
    slug: "new-to-christianity",
    kicker: "New here?",
    title: "I am new to Christianity",
    body: "Start with the essentials. Who is God, who is Jesus, and what does the Bible actually say?",
    to: "/start-here",
    cta: "Begin Here",
  },
  {
    slug: "how-to-be-forgiven",
    kicker: "Seeking forgiveness",
    title: "How can I be forgiven?",
    body: "You do not need to earn God's love. See how the Gospel offers real forgiveness through Jesus Christ.",
    to: "/articles/how-can-i-be-forgiven",
    cta: "Read the Answer",
  },
  {
    slug: "read-the-bible",
    kicker: "Reading the Bible",
    title: "How do I start reading the Bible?",
    body: "A gentle, honest guide for anyone opening the Scriptures for the first time.",
    to: "/articles/how-to-begin-reading-the-bible",
    cta: "Start Reading",
  },
  {
    slug: "growing-christian",
    kicker: "Growing in faith",
    title: "How can I grow as a Christian?",
    body: "Prayer, Scripture, community, and walking humbly with the God who first loved you.",
    to: "/articles/assurance-of-salvation",
    cta: "Keep Growing",
  },
];

export const FOOTER_COLUMNS = [
  {
    title: "Discover",
    links: [
      { slug: "start-here", label: "Start Here", to: "/start-here" },
      { slug: "eternal-life", label: "What Is Eternal Life?", to: "/eternal-life" },
      { slug: "know-jesus", label: "Who Is Jesus?", to: "/know-jesus" },
      { slug: "the-gospel", label: "The Gospel", to: "/the-gospel" },
    ],
  },
  {
    title: "Study",
    links: [
      { slug: "articles", label: "Articles", to: "/articles" },
      { slug: "bible-studies", label: "Bible Studies", to: "/bible-studies" },
      { slug: "devotionals", label: "Daily Devotional", to: "/devotionals" },
      { slug: "questions", label: "Questions & Answers", to: "/questions" },
      { slug: "what-we-believe", label: "What We Believe", to: "/what-we-believe" },
    ],
  },
  {
    title: "Community",
    links: [
      { slug: "kids", label: "Kids & Families", to: "/kids" },
      { slug: "contact", label: "Contact", to: "/contact" },
      { slug: "prayer", label: "Request Prayer", to: "/contact#prayer" },
      { slug: "ask", label: "Ask a Question", to: "/contact#ask" },
      { slug: "languages", label: "Languages", to: "/languages" },
    ],
  },
  {
    title: "Trust",
    links: [
      { slug: "about", label: "About", to: "/about" },
      { slug: "editorial-standards", label: "Editorial Standards", to: "/legal/editorial-standards" },
      { slug: "child-safety", label: "Child-Safety Policy", to: "/legal/child-safety" },
      { slug: "bible-copyright", label: "Bible Copyright", to: "/legal/bible-copyright" },
      { slug: "privacy", label: "Privacy Policy", to: "/legal/privacy" },
      { slug: "terms", label: "Terms of Use", to: "/legal/terms" },
      { slug: "accessibility", label: "Accessibility", to: "/legal/accessibility" },
    ],
  },
];
